<!--
 * @Author: xiehangyi
 * @LastEditors: xiehangyi
 * @Description: 放大镜渲染态
-->
<template>
  <div class="lc-magnifier">
    <div class="lc-magnifier-text" @click="magnifierDialog=true">
      {{ formattingString || num }}
    </div>
    <el-dialog
      v-model="magnifierDialog"
      width="80%"
      center
      :append-to-body="true"
    >
      <div class="lc-magnifier-dialog-text">
        {{ formattingString || num }}
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  name: 'LcMagnifier',
  props: {
    //每几位添加空格
    addSpace: {
      type:  [Number, String],
      default: ''
    },
    //特殊格式化
    specialFormatting: {
      type:  [Number, String],
      default: ''
    },
    //需要格式化值
    num: {
      type:  [Number, String],
      default: '19999898899'
    },
    // 替换值
    replaceValue: {
      type:  [Number, String],
      default: ''
    },
    //输入正则
    regExp: {
      type:  [Number, String],
      default: ''
    },
  },
  data() {
    return {
      magnifierDialog: false,
      formattingString: this.num,
    };
  },
  computed: {
  },
  watch: {
    specialFormatting: {
      handler(val) {
        val && this.specialFormattingFun(JSON.parse(val));
      },
      immediate:true,
    },
    regExp: {
      handler(val) {
        val && this.regExpFun(this.regExp, this.replaceValue);
        !val && !this.specialFormatting && (this.formattingString = this.num);
      },
      immediate:true,
    },
    replaceValue: {
      handler(val) {
        val && this.regExpFun(this.regExp, this.replaceValue);
        !val && !this.specialFormatting && (this.formattingString = this.num);
      },
      immediate:true,
    },
  },
  created() {
  },
  mounted() {
    // preset
  },
  methods: {
    specialFormattingFun(val) {
      const startNum = val[0];
      const endNum = val[1];
      this.formattingString = this.num.replace(/\s/g, "").replace(new RegExp('\(?<=.{' + startNum + '}).(?=.{' + endNum + '})','g'),"*");
    },
    regExpFun() {
      this.formattingString = this.num.replace(new RegExp(`${this.regExp}`, 'g'), this.replaceValue);
    }
  },
};
</script>
